import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { azureSortedAccountsSelector } from "./azureSortedAccountsSelector";
import { nonDeletedAndNotBillingAccountsCombiner } from "../../combiners/nonDeletedAndNotBillingAccountsCombiner";

export const azureNonDeletedAndNotBillingAccountsSelector =
  createDraftSafeSelector(
    [azureSortedAccountsSelector],
    nonDeletedAndNotBillingAccountsCombiner,
  );
